define([], ()=> {
    return ['JsonRPCService', (JsonRPCService)=> {
        return {
            getAccountPolicySummaries: (callGroups)=> {
                return JsonRPCService.send('pc', 'policy/policy', 'getAccountPolicySummaries', [], callGroups);
            },
        };
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/services/PolicyService.js